/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Job } from "./Job";
import { JobExecutionPlan } from "./JobExecutionPlan";
export const JobPlan = core.serialization.object({
    job: Job,
    plan: JobExecutionPlan,
});
